module.exports = __webpack_public_path__ + "img/plus.26960b26.svg";